import { useTheme } from "@emotion/react";
import { ChevronLeft, Menu as MenuIcon } from "@mui/icons-material";
import { MenuItem, MenuList } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { compose } from "@reduxjs/toolkit";
import clsx from "clsx";
import { default as React, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Text, View } from "../components";
import * as styleGlobal from "../infra/styleGlobal";
import * as actions from "../redux/actions/actions.js";
const drawerWidth = 240;

const Dashboard = (props) => {
  const theme = useTheme();
  const classes = gsUI(theme);
  const [state, setState] = useState({
    open: false,
  });
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setState({ ...state, open: !state.open });
  };
  const goTo = (path) => () => {
    navigate(path);
    setState({ ...state, open: false });
  };
  const header = () => {
    const { open } = state;
    return (
      <AppBar position="absolute" elevation={0} style={{ ...classes.appBar, ...(open && classes.appBarShift) }}>
        <Toolbar className={classes.toolbar}>
          {!state.open && (
            <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={toggleDrawer} className={clsx(classes.menuButton, open && classes.menuButtonHidden)}>
              <MenuIcon {...styleGlobal.StyleIconBotao} />
            </IconButton>
          )}
          <View style={{ flexDirection: "row", flex: 1, justifyContent: "flex-end" }}></View>
        </Toolbar>
      </AppBar>
    );
  };

  const menu = () => {
    const { open } = state;
    return (
      <Drawer
        PaperProps={{
          sx: {
            ...classes.drawerPaper,
            ...(!open && classes.drawerPaperClose),
          },
        }}
        // onMouseEnter={() => {
        //   this.setState({ open: true });
        // }}
        // onMouseLeave={() => {
        //   this.setState({ open: false });
        // }}
        open={open}
      >
        <View style={{ flexDirection: "row", justifyContent: "center" }} className={classes.toolbarIcon}>
          <IconButton onClick={toggleDrawer}>
            <ChevronLeft style={{ color: "black" }} />
          </IconButton>
          <Text style={{ alignSelf: "center", fontWeight: "bold", fontSize: 18 }}>Frostgrave</Text>
        </View>
        <Divider />
        <MenuList>
          <MenuItem onClick={goTo("/")}>Roll for Monsters</MenuItem>
          <MenuItem onClick={goTo("/events")}>Events</MenuItem>
          <MenuItem onClick={goTo("/listmonsters")}>Monster List</MenuItem>
          <MenuItem onClick={goTo("/traits")}>All traits</MenuItem>
          <MenuItem onClick={goTo("/listpotions")}>Potions List</MenuItem>
          <MenuItem onClick={goTo("/listsoldiers")}>Soldiers List</MenuItem>
          <MenuItem onClick={goTo("/listmagicitems")}>Maigc Items List</MenuItem>
          <MenuItem onClick={goTo("/listspells")}>Spells</MenuItem>
          <MenuItem onClick={goTo("/listbase")}>Base/Upgrades</MenuItem>
          <MenuItem onClick={goTo("/ListTreasureTables")}>TreasureTables List </MenuItem>
          <MenuItem onClick={goTo("/armyoprquest")}>Army Opr Quest</MenuItem>
        </MenuList>
      </Drawer>
    );
  };

  //

  const { MainRouter } = props;
  return (
    <div className={classes.root}>
      <CssBaseline />
      {header()}
      {menu()}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {MainRouter()}
      </main>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  logout: () =>
    actions.logout((data) => {
      dispatch(data);
    }),
});
const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  empresa: state.Reducer.empresa,
});

export const gsUI = (theme) => ({
  root: {
    display: "flex",
  },
  bottomapp2: {
    flexDirection: "row",
    minWidth: 200,
    boxShadow: "none",
    backgroundColor: styleGlobal.color3,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: styleGlobal.color4,
    padding: 10,
    "&:hover": {
      boxShadow: "none",
      backgroundColor: "rgba(0,0,0,0.2)",
    },
    minHeight: 35,
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 5,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingBottom: 7.5,
    paddingTop: 7.5,
    minHeight: 65,
    borderColor: "red",
  },
  toolbarIcon: {
    display: "flex",
    flexDirection: "row",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 10,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    alignSelf: "",
  },
  drawerPaper: {
    borderRight: "none",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    borderRight: "none",
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(15),
    width: 0,
    [theme.breakpoints.down(880)]: {
      width: 0,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    backgroundColor: styleGlobal.color8,
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Dashboard);
